module.exports = __webpack_public_path__ + "img/MapOutlined.f74a9bf9.svg";